













import { TransformedQuantumChartReportSettings } from '@/types/QuantumChartReportServiceType'
import QuantumChart from '@stackdc/quantum-charts'
import Vue from 'vue'

export default Vue.extend({
    components: {
        QuantumChart
    },
    props: {
        quantumChartReportSettings: {
            type: Object as () => TransformedQuantumChartReportSettings,
        },
        api: {
            type: String,
        },
        isEditMode: {
            type: Boolean,
            default: false
        },
        currentPivotSettingKey: {
            type: String,
            default: ''
        },
        chartTitle: {
            type: String,
            default: 'export'
        }
    },
    mounted() {
        if(!this.isEditMode) {
            this.loadState()
            this.loadData()
        }
        
        this.settings = {
            ...this.quantumChartReportSettings.settings,
            showFieldChooser: false,
            isReadOnly: true
        }

    },
    data() {
        return {
            settings: {},
        }
    },
    methods: {
        async onDataLoad() {
            return (await this.axios.post(this.api, { ...this.quantumChartReportSettings.searchOption, pageSize: -1 })).data
        },
        loadData() {
            const qchartRef = this.$refs.qchart as any
            qchartRef.loadData()
        },
        loadState() {
            setTimeout(() =>{
                const qchartRef = this.$refs.qchart as any
                qchartRef.loadState(this.quantumChartReportSettings.pivotState)
            }, 1000)
        },
        onExportCallback(wb: any) {
            if(this.quantumChartReportSettings.searchOption.searchFilters.length < 1) {
                return
            }
            
            const sheet = wb.addWorksheet('Search Filters')

            sheet.columns = [
                { header: 'Field', key: 'field', width: 10},
                { header: 'Operator', key: 'operator', width: 32 },
                { header: 'Value', key: 'value', width: 10 },
                { header: 'Operand', key: 'logic', width: 10 }
            ]
            sheet.getRow(1).font = { name: 'Calibri', size: 11, bold: true } 


            for(let i = 0; i< this.quantumChartReportSettings.searchOption.searchFilters.length; i++) {
                let current = this.quantumChartReportSettings.searchOption.searchFilters[i] as any
                let row = sheet.getRow(i+2)
                sheet.columns.forEach( (column: any) => {
                    const currentKey = column['key']
                    if(currentKey) {
                        row.getCell(currentKey).value = current[currentKey]
                    }
                    
                })
            }

            // format sheet
            sheet.columns.forEach( (column: any) => {
                let maxLength = 0
                if(column && column['eachCell']) {
                    column['eachCell']({ includeEmpty: true }, (cell: any)  => {
                        let columnLength = cell.value ? cell.value.toString().length : 10
                        if (columnLength > maxLength ) {
                            maxLength = columnLength
                        }
                    })
                    column.width = maxLength < 10 ? 10 : maxLength
                }
            })
        }
    }
})
